import { retrieveAllFaqs } from "../../../redux/public-slices/other.slice"
import { Fragment, lazy, Suspense, useEffect, useState } from "react"
import SectionSkeleton from "../../../components/ui/SectionSkeleton"
import SearchInput from "../../../components/ui/SearchInput"
import { useDispatch, useSelector } from "react-redux"
import { Link as NavLink } from "react-router-dom"
import Images from "../../../assets/js/Images"
import Icons from "../../../assets/js/Icons"

import {
  Accordion, AccordionDetails, AccordionSummary, Alert, Box,
  Button, Container, Grid2 as Grid, Icon, Skeleton, Typography
} from "@mui/material"

const TopBannerB = lazy(() => import("../../../components/common/TopBannerB"))
const CtaSection = lazy(() => import("../../../components/ui/CtaSection"))

function Faqs() {
  const dispatch = useDispatch()
  const [data, setData] = useState(null)
  const [expended, setExpended] = useState(0)
  const { loadings } = useSelector(state => state.otherSlice)

  // Expand role
  const handleExpend = (type) => {
    setExpended(type)
  }

  // Handle get all FAQs
  const handleGetAll = (filters) => {
    dispatch(retrieveAllFaqs({
      limit: filters?.limit || 20,
      search: filters?.search || null,
      currentPage: filters?.currentPage || null,
    })
    ).unwrap().then((response) => {
      setData(response)
    }).catch((error) => {
      console.error("FAQ Error:", error)
    })
  }

  useEffect(() => {
    handleGetAll()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerB
          bannerImg={Images?.faqs}
          headline="Our Mission: Your Emotional Wellness"
          subHeadline="We're committed to helping individuals lead healthier, happier lives."
        />
      </Suspense>

      <Box component="section" sx={{ py: { xs: 12, lg: 15 } }}>
        <Container maxWidth={false} fixed>
          <Box maxWidth="1000px" mx="auto">
            <SearchInput />

            <Grid container spacing={3} mt={4}>
              {loadings?.retrieveAll ?
                new Array(5).fill().map((_, i) => (
                  <Grid key={i} size={12}>
                    <Skeleton
                      sx={{
                        height: "38px",
                        width: "100%",
                        transform: "none"
                      }}
                    />
                  </Grid>
                )) :
                data?.records?.length > 0 ?
                  data?.records?.map((faq, i) => (
                    <Grid key={i} size={12}>
                      <Accordion
                        variant="faqListing"
                        expanded={expended === i}
                        onChange={() => { handleExpend(i) }}
                        slotProps={{ heading: { component: "div" } }}
                      >
                        <AccordionSummary
                          sx={{
                            fontSize: "16px",
                            fontWeight: "500",
                            fontFamily: "Poppins",
                            minHeight: "auto !important",
                            ".MuiAccordionSummary-content": { my: "8px !important" }
                          }}
                          expandIcon={
                            <Icon sx={{ fontSize: "20px" }}>
                              <Icons.ArrowDown1 />
                            </Icon>
                          }
                        >
                          <Typography variant="bodyLead">{faq?.question}</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ fontWeight: "400" }}>
                          <Typography
                            color="other.color1"
                            variant="bodyNormal"
                          >{faq?.answer}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  )) :
                  <Alert
                    sx={{
                      width: "100%",
                      fontSize: "16px",
                      fontWeight: "500",
                      borderWidth: "2px",
                      fontFamily: "Poppins",
                    }}
                    severity="info"
                    color="primary"
                    variant="outlined"
                  >No data found!
                  </Alert>
              }
            </Grid>
          </Box>
        </Container>
      </Box>

      <Suspense fallback={<SectionSkeleton />}>
        <CtaSection>
          <Typography
            variant="ctaNormal"
          >Still Have Questions?
          </Typography>
          <Button
            to="/help-center"
            variant="CtaButton"
            LinkComponent={NavLink}
          >Contact Us
          </Button>
        </CtaSection>
      </Suspense>
    </Fragment >
  )
}

export default Faqs